export default{
    MINUTO:1,
    HORA:2,
    DIA:3,
    SEMANA:4,
    MES:5,
    ANO:6
}